<template>
    <div class="quote">
        <div id="navTitle">
            <img class="black" @click="back" src="@/assets/images/template/a_top_return.png"/>
            <img class="black product-btn" @click="showProductPicker" src="@/assets/images/template/a_top_product.png"/>
            <img class="treaty" @click="goAttribute" src="@/assets/images/template/a_top_treaty.png"/>
            <img class="search-btn" @click="goSearch" src="@/assets/images/template/a_top_search.png"/>
        </div>
        <div id="content">
            <div class="slider">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-if="tickList.length<6"><div class="item" @click="changeProduct(quote.notify[code].uiCodeID,$route.query.index)"><span>{{quote.notify[code].szShortName}}</span></div></swiper-slide>
                    <swiper-slide v-for="(data,index) in tickList" v-else><div class="item" @click="changeProduct(data.uiCodeID,index)"><span>{{data.symbol}}</span></div></swiper-slide>
                    <swiper-slide class="visibility"><div class="item"><span></span></div></swiper-slide>
                </swiper>
            </div>
            <Charts :code="code"></Charts>
            <!--<AboutNews :code="code"></AboutNews>-->
            <div class="botFixed">
                <ul>
                    <li><p class="buy" @click="clickPop(1)">{{$t("trade.products.buy")}}</p></li>
                    <li><p class="sell" @click="clickPop(2)">{{$t("trade.products.sell")}}</p></li>
                </ul>
            </div>
            <MarketNorm :code="code" ref="child"></MarketNorm>
            <QuoteSearch ref="search"></QuoteSearch>
            <ProductPicker ref="productPicker"></ProductPicker>
        </div>
        <tab></tab>
        <!--游客-->
        <div class="popFixed" v-if="isGuest">
            <div class="masking" @click="guestPop"></div>
            <div class="tcCon">
                <div class="item">
                    <span>{{$t("message.point")}}</span>
                    <p>{{$t("message.info_noLogin")}}</p>
                </div>
                <div class="btnCon">
                    <span @click="goAccount">{{$t("login.openAccount")}}</span>
                    <span @click="goLogin">{{$t("login.submit")}}</span>
                </div>
            </div>
        </div>
        <!--真实账号资金是否充足-->
        <RFundsPop ref="rFunds" :user="user"></RFundsPop>
        <!--模拟账号资金是否充足-->
        <DFundsPop ref="dFunds" :user="user"></DFundsPop>
    </div>
</template>

<script>
    require('swiper/dist/css/swiper.css');
    require('@/assets/css/quoteChart.css');
    import Tab from '@/view/module/Tab.vue'
    import Charts from '@/view/quotation/Charts.vue'
    import AboutNews from '@/view/news/AboutNews.vue'
    import MarketNorm from '@/view/quotation/MarketNorm.vue'
    import ProductPicker from '@/view/quotation/ProductPicker.vue'
    import QuoteSearch from '@/view/quotation/QuoteSearch.vue'
    import RFundsPop from '@/view/module/RFundsPop.vue'
    import DFundsPop from '@/view/module/DFundsPop.vue'
    import Constant from '@/utils/Constant'
    import {swiper, swiperSlide} from 'vue-awesome-swiper'
    import {mapState} from 'vuex'

    export default {
        name: "QuoteChart",
        components: { Tab,swiper, swiperSlide,Charts,AboutNews,MarketNorm,ProductPicker,QuoteSearch,RFundsPop,DFundsPop},
        computed:{
            ...mapState(['quote','socket','symbolInfo',"user",'locale',"account"]),
            tickList: {
                get() {
                    let newTickList=[];
                    for(const j in this.quote.tickList){
                        if(this.code == this.quote.tickList[j].uiCodeID){
                            newTickList.push(this.quote.tickList[j]);
                            break;
                        }
                    }
                   
                    return newTickList;
                }
            },
            attribute: {
                get() {
                    if (this.quote.notify[this.$route.query.id]) {
                        const sourceCode = this.quote.notify[this.$route.query.id].uiSourceCode;
                        return this.symbolInfo.codeMap[sourceCode] || {};
                    }
                    return {};
                }
            },
        },
        data(){
            let _this=this;
            return{
                wwwUrl:process.env.VUE_APP_WWW,
                uiCodeIDs: process.env.VUE_APP_PRODUCTS,
                code: this.$route.query.id || "",
                swiperOption: {
                    notNextTick: true,
                    initialSlide: this.$route.query.index||'',
                    resistanceRatio: 0,
                    slidesPerView: 'auto',
                    slideToClickedSlide: true,
                    on: {
                        slideChangeTransitionEnd: function () {
                            _this.$router.push({path: "/home/quoteChart", query: {id: _this.uiCodeIDs.split(",")[this.activeIndex],index:this.activeIndex}});
                        }
                    }
                },
                isGuest:false,
                errMessage:'',
                productList:process.env.VUE_APP_PRODUCTS.split(","),
            }
        },
        methods:{
            back() {
                this.$router.push({path: '/home'})
            },
            goAttribute() {
                this.$bus.$emit('loading', false);
                if (!this.user.loginname) {
                    this.$bus.$emit('loading', true);
                    this.isGuest = !this.isGuest;
                } else this.$router.push({path: "/home/attribute", query: {id: this.code}})
            },
            guestPop(){
                this.isGuest=!this.isGuest;
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
            },
            goLogin() {
                this.$bus.$emit('loading', false);
                this.$router.push({path: "/login"});
                let mainH = document.getElementById("main");
                mainH.classList.remove('mainFixed');
            },
            goAccount() {
                this.$bus.$emit('loading', false);
                window.location.href = `${process.env.VUE_APP_H5_ACCOUNT_URL}?pageType=mobile&locale=${this.locale}`
                // this.$bus.$emit('loading', false);
                // let url = this.wwwUrl + 'register?locale=' + this.locale+'&pageType=trade&skinType=trade1';
                // this.$router.push({
                //     path: '/home/embed', query: {
                //         title: this.$t('login.openAccount'),
                //         url: url
                //     }
                // });
            },
            clickPop(direct) {
                if (this.user.loginname) {
                    if(this.account.balance<=0){
                        if (String(this.user.loginname).startsWith("1")) this.$refs.dFunds.fundsPop();
                        else this.$refs.rFunds.fundsPop()
                    }
                    else this.$refs.child.clickPop(direct)
                } else {
                    this.isGuest = !this.isGuest;
                    let mainH = document.getElementById("main");
                    mainH.classList.toggle('mainFixed');
                }
                return this.errMessage
            },
            changeProduct: function (obj,index) {
                this.$router.push({path: "/home/quoteChart", query: {id: obj,index:index}});
            },
            showProductPicker(){
                console.log("show product picker");
                this.$refs.productPicker.toggle();
            },
            goSearch(){
                this.$refs.search.show();
            },
            requestQuote(currentCode){
                var productListWithCurrentCode = this.productList.concat(currentCode);
                //订阅数据字典有的数据
                this.socket.quoteSocket.emit('request', Number(Constant.Req.subsTick), {
                    "UserID": this.account.userId,
                    "GroupID": this.account.groupId,
                    "uiCodeIDList": productListWithCurrentCode
                });
                //分页请求数据字典中数据的最后一口报价(个人猜测:一次请求产品不能超过15个,否则请求失效)
                let lastTick = {};
                for (const i in productListWithCurrentCode) {
                    lastTick[i] = productListWithCurrentCode[i];
                }
                this.socket.quoteSocket.emit('request', Number(Constant.Req.lastTick), lastTick);
            }
        },
        mounted(){
            window.scrollTo(0,0);
            this.$bus.$emit('loading', true);
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');

            this.requestQuote(this.code);
        },
        activated(){
            window.scrollTo(0,0);
            this.$bus.$emit('loading', true);
        },
        watch: {
            // 路由监听
            $route: {
                deep: true,
                handler: function (val, oldVal) {
                    console.log("QuoteChart route changed:", val, oldVal);
                    this.requestQuote(val.query.id);

                    if (val.query.id != oldVal.query.id) {
                        this.code = val.query.id;
                        this.$refs.mySwiper.swiper.activeIndex = val.query.index
                    }
                }
            }
        },
    }
</script>
